import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { SurveyFull } from 'entities/Surveys/model/SurveyFull'
import { detailsSurvey } from 'pages/surveys/ui/actions/detailsSurvey/detailsSurvey'
import { duplicate } from 'pages/surveys/ui/actions/duplicate/duplicate'
import { deleteSurvey } from 'pages/surveys/ui/actions/deleteSurvey/deleteSurvey'
import { SurveysPath } from 'pages/surveys/route/surveysPath'
import { editSurvey } from './editSurvey/editSurvey'

export const getSurveyViewActions = (item: SurveyFull): ActionItem[] => {
  return [
    editSurvey(item.id),
    detailsSurvey({
      id: item.id,
      name: item.name,
      status: item.status,
    }),
    duplicate(item.id),
    deleteSurvey(item.id, () => {
      uiStore.changeRouteViaVue({
        path: `/${SurveysPath.root}`,
      })
    }),
  ]
}
